<span [attr.id]="id" class="app-link">
  @if (icon) {
    <app-icon [name]="icon" color="#1976d2"></app-icon>
  }
  <span class="link-text">
    <ng-content></ng-content>
  </span>
</span>
